import ResetpasswordForm from './model/form.model';

class ResetpasswordController {
  constructor(AccountApiService, $window, $location, $translate) {
    'ngInject';

    this.AccountApiService = AccountApiService;
    this.$window = $window;
    this.$location = $location;
    this.$translate = $translate;
  }

  $onInit() {
    this.form = new ResetpasswordForm();
    this.getCodeFromIframe = this.getCodeFromIframe.bind(this);
    this.$window.addEventListener('message', this.getCodeFromIframe);

    this.form.resetCode = this.$location.search().reset_password_code;
    this.validateCode();
  }

  getCodeFromIframe(e) {
    let parseData = JSON.parse(e.data);
    this.form.resetCode = parseData.pass_code;
    this.validateCode();
  }

  validateCode() {
    this.form.successMessage = false;
    const locale = this.$location.search().lang || 'en';
    this.$translate.use(locale);

    this.AccountApiService.validateResetCode(locale, this.form.resetCode)
    .then((resp) => {
      $('#error-message').remove();
      this.form.successMessage = true;
    })
    .catch((errors) => {
      this.form.errorMessage = errors;
      if (errors.code) {
        this.form.errorMessage = errors.message;
      }
      this.form.loadingMessage = 'Oh snap!';
      this.form.successMessage = false;
    })
    ;
  }

  sendPostMessageToForgotPass() {
    parent.postMessage('amsForgot-pass', '*');
  }
}

export default ResetpasswordController;



// WEBPACK FOOTER //
// ./client/app/pages/resetpassword/resetpassword.controller.js